module.exports = __webpack_public_path__ + "static/media/adobexd.b3294f58.png";